import React, { useState, useEffect } from "react";
import api from '../services/api';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

export default function CompromissosBarras({ label = "Média", ids = "" }) {
    const token = localStorage.getItem('token');
    const [slaGraficoBarras, setSlaGraficoBarras] = useState([]);
    const buscar = () => {
        api({
            method: 'get',
            action: '/slaCompromissoData/compromissosBarras',
            token: token,
            params: { ids: ids }
        })
            .then(response => {
                setSlaGraficoBarras(response.data.data);
            }).catch(err => {
                //console.log(err)
            });
    };

    useEffect(() => {
        buscar();
    }, 
    // eslint-disable-next-line
    []);

    return (
        <div className="card">
            <div className="card-body">
                {
                    Object.keys(slaGraficoBarras).map(function (key, index) {
                        const data = [
                            {
                                name: slaGraficoBarras[key].titulo,
                                value: slaGraficoBarras[key].media
                            }
                        ];
                        return (
                            <div key={index} style={{ marginBottom: '20px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                                    <span style={{ fontSize: '14px', fontWeight: 'bold' }}>{slaGraficoBarras[key].titulo}</span>
                                    <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{slaGraficoBarras[key].media}%</span>
                                </div>
                                <ResponsiveContainer width="100%" height={70}>
                                    <BarChart
                                        layout="horizontal"
                                        data={data}
                                        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis type="number" domain={[0, 100]} hide />
                                        <YAxis type="category" dataKey="name" hide />
                                        <Tooltip />
                                        <Bar dataKey="value" fill="#39539E" radius={[0, 4, 4, 0]}>
                                            <Cell fill="#39539E" />
                                        </Bar>
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
}
